import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SurveyBuilderHelpModalComponent } from './survey-builder-help-modal.component';
import { FormsModule } from "@angular/forms";
import { ModalModule } from 'ngx-bootstrap/modal';
import { SurveyBuilderHelpContentModule } from '../survey-builder-help-content/survey-builder-help-content.module';
import { ButtonModule } from '@xref/xref-lib';

@NgModule({
  declarations: [SurveyBuilderHelpModalComponent],
  imports: [
    CommonModule,
    FormsModule,
    ModalModule,
    ButtonModule,
    SurveyBuilderHelpContentModule
  ],
  exports: [SurveyBuilderHelpModalComponent]
})
export class SurveyBuilderHelpModalModule { }
